import React, { FC } from 'react';
import styles from './title.module.scss';

export const EntitiesCardTitle: FC = ({ children }) => (
  <div className={styles.container}>{children}</div>
);
